// Mirrors _features/roles/state/slice.js's shape. New file - Usage
// Collection previously had no Redux state at all (local useState pagination
// only), part of the deliberate "no filter bar" scope decision the Tier 2
// toolbar work reverses.
import { createSlice } from "@reduxjs/toolkit";
import { REHYDRATE } from "redux-persist";

const DEFAULT_SORT = "-createdAt";

const initialState = {
  selectedFilters: {
    sort: DEFAULT_SORT,
  },
};

const usageCollectionFeatureSlice = createSlice({
  name: "usageCollectionFeature",
  initialState,
  reducers: {
    updateSelectedFilters: (state, action) => {
      state.selectedFilters = action.payload;
    },
    resetSelectedFilters: (state) => {
      state.selectedFilters = {
        sort: DEFAULT_SORT,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(REHYDRATE, (state, action) => {
      if (action.payload && action.payload.usageCollectionFeature) {
        const persistedFilters = action.payload.usageCollectionFeature.selectedFilters;

        return {
          ...state,
          selectedFilters: {
            ...(persistedFilters && typeof persistedFilters === "object" ? persistedFilters : {}),
            sort: persistedFilters?.sort || DEFAULT_SORT,
          },
        };
      }
      return state;
    });
  },
});

export const { updateSelectedFilters, resetSelectedFilters } = usageCollectionFeatureSlice.actions;

export default usageCollectionFeatureSlice.reducer;
